import React, { useState, useCallback } from 'react';
import t from '~t';
import {
  Modal,
  ModalHeader as Header,
  Button,
  Layout,
  Text,
} from '~ui';

export default function DialogPromptView({
  id,
  message,
  ok,
  cancel,
  description,
  value: initialValue = '',
  sendResult,
}) {
  const [value, setValue] = useState((initialValue || '') + '');

  const onFieldChange = useCallback(
    (e) => setValue(e.target.value),
    [],
  );

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      sendResult(id, value);
    },
    [id, value, sendResult],
  );

  const onCancel = useCallback(() => {
    sendResult(id, '');
  }, [id, sendResult]);

  return (
    <Modal className='w-[10rem]' important={true} onClose={onCancel}>
      <Header title={message} data-no-shadow />

      <form onSubmit={onSubmit}>
        <Layout>
          {description ? (
            <div className='text-foreground'>{description}</div>
          ) : null}

          <Text
            autoFocus
            selectAll
            autoSize
            value={value}
            onChange={onFieldChange}
          />

          <Button data-block type='submit'>
            {ok || 'OK'}
          </Button>

          <Button data-block variant='outline' onClick={onCancel}>
            {cancel || t.s('cancel')}
          </Button>
        </Layout>
      </form>
    </Modal>
  );
}
